/** @jsx jsx */
import { jsx, useTheme } from '@emotion/react';

import useRouter from 'js/lib/useRouter';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import EnterpriseSearch from 'bundles/enterprise-learner-search/components/search/EnterpriseSearch';
import SearchResultBanner from 'bundles/enterprise-learner-search/components/skillsetSearch/SearchResultBanner';
import { isSearchTheme } from 'bundles/search-common/searchTheme';

type PropsFromCaller = {
  programIds: Array<string>;
  thirdPartyOrganizationId: string;
  programHomeLink: string;
  programSlug: string;
};

export const EnterpriseSearchPageRoot = ({
  programHomeLink,
  programSlug,
  programIds,
  thirdPartyOrganizationId,
}: PropsFromCaller) => {
  const theme = useTheme();
  const router = useRouter();

  const {
    location: {
      query: { query: searchQuery },
    },
  } = router;

  if (!isSearchTheme(theme)) {
    throw new Error(
      'SearchPage can only be used in the context of a SearchTheme. Wrap this component with a ThemeProvider.'
    );
  }

  return (
    <main data-testid="SearchPageRoot" css={theme.searchPageContainer}>
      <div css={{ backgroundColor: 'white' }}>
        <PageGridContainer maxWidth="lg">
          <Grid item xs={12}>
            <div css={{ marginTop: theme.spacing(8) }}>
              <SearchResultBanner
                thirdPartyOrgId={thirdPartyOrganizationId}
                programSlug={programSlug}
                programHomeLink={programHomeLink}
                currentRefinement={searchQuery}
                programIds={programIds}
                showDivider={false}
              />
            </div>
          </Grid>
        </PageGridContainer>
      </div>
      <div css={theme.mainContent}>
        <PageGridContainer maxWidth="lg">
          <Grid item xs={12}>
            <EnterpriseSearch
              programIds={programIds}
              thirdPartyOrganizationId={thirdPartyOrganizationId}
              isEnterpriseSERP={true}
            />
          </Grid>
        </PageGridContainer>
      </div>
    </main>
  );
};

export default EnterpriseSearchPageRoot;
